import _regeneratorRuntime from 'babel-runtime/regenerator';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import isModern from './utils/isModern';
import loadImage from './utils/loadImage';
import states from './utils/states';

import './index.css';

var FittedImage = function (_Component) {
  _inherits(FittedImage, _Component);

  function FittedImage(props) {
    _classCallCheck(this, FittedImage);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      status: states.PENDING
    };
    return _this;
  }

  FittedImage.prototype.componentDidMount = function componentDidMount() {
    if (this.props.loader) {
      this._loadImage();
    }
  };

  FittedImage.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.props.src !== props.src) {
      this._loadImage();
    }
  };

  FittedImage.prototype.render = function render() {
    if (this.props.loader && !this._isLoaded()) {
      return this.props.loader;
    }

    return this._getImage();
  };

  FittedImage.prototype._getClassName = function _getClassName(background) {
    return ['FittedImage', background ? 'FittedImage--background' : null, 'FittedImage--' + this.props.fit, this.props.className].filter(function (item) {
      return !!item;
    }).join(' ');
  };

  FittedImage.prototype._getImage = function _getImage() {
    /* eslint-disable no-unused-vars */
    var _props = this.props,
        background = _props.background,
        fit = _props.fit,
        src = _props.src,
        loader = _props.loader,
        onLoad = _props.onLoad,
        onError = _props.onError,
        props = _objectWithoutProperties(_props, ['background', 'fit', 'src', 'loader', 'onLoad', 'onError']);

    if (!background && isModern) {
      return React.createElement('img', _extends({}, props, { src: src, className: this._getClassName(false) }));
    }

    return React.createElement('div', _extends({}, props, {
      style: Object.assign({}, this.props.style, { backgroundImage: 'url(' + this.props.src + ')' }),
      className: this._getClassName(true) }));
  };

  FittedImage.prototype._isLoaded = function _isLoaded() {
    return states.LOADED === this.state.status;
  };

  FittedImage.prototype._loadImage = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.setState({
                status: states.LOADING
              });

              _context.prev = 1;
              _context.next = 4;
              return loadImage(this.props.src);

            case 4:
              _context.next = 9;
              break;

            case 6:
              _context.prev = 6;
              _context.t0 = _context['catch'](1);

              this._onLoadError();

            case 9:

              this._onLoadSuccess();

            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 6]]);
    }));

    function _loadImage() {
      return _ref.apply(this, arguments);
    }

    return _loadImage;
  }();

  FittedImage.prototype._onLoadSuccess = function _onLoadSuccess() {
    this.setState({
      status: states.LOADED
    });

    this.props.onLoad();
  };

  FittedImage.prototype._onLoadError = function _onLoadError() {
    this.setState({
      status: states.DEAD
    });

    this.props.onError();
  };

  return FittedImage;
}(Component);

FittedImage.propTypes = process.env.NODE_ENV !== "production" ? {
  background: PropTypes.bool,
  className: PropTypes.string,
  fit: PropTypes.oneOf(['auto', 'contain', 'cover']),
  loader: PropTypes.element,
  src: PropTypes.string.isRequired,
  style: PropTypes.object,
  onLoad: PropTypes.func,
  onError: PropTypes.func
} : {};

FittedImage.defaultProps = {
  background: false,
  fit: 'auto',
  style: {},
  onLoad: function onLoad() {},
  onError: function onError() {}
};

export default FittedImage;